import * as types from '../actiontypes';

import {API_RESOURCES, createApiDeleteAction, createApiReadAction, createApiUpdateAction} from '../../util/api';

import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export const getSTEntityById = (engagementId, multiEntityId, queryString) => {
	return createApiReadAction(
		types.GET_STENTITY_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: multiEntityId
		},
		queryString,
		multiEntityId
	);
};

export const getALLMultiEntity = (engagementId, queryString, actionProps) => {
	return createApiReadAction(
		types.GET_ALL_MULTI_ENTITY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: null
		},
		queryString,
		{
			...actionProps,
			resolve: true
		}
	);
};

export const createSTEntity = (url, data, actionProps) => {
	return {
		type: types.CREATE_STENTITY,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		}
	};
};

export const updateSTEntity = (url, data, actionProps) => {
	return {
		type: types.UPDATE_STENTITY,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'PUT',
				data
			}
		}
	};
};

export const profileSubmit = (engagementId, data) => {
	return createApiUpdateAction(
		types.SUBMIT_PROFILE,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: null,
			[API_RESOURCES.PROFILE]: null
		},
		data
	);
};

export const clearMultiEntity = () => {
	return {
		type: types.CLEAR_MULTI_ENTITY
	};
};

export const getMultiEntityById = (engagementId, multiEntityId, queryString, actionProps) => {
	return createApiReadAction(
		types.GET_MULTI_ENTITY_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: multiEntityId
		},
		queryString,
		{multiEntityId, actionProps}
	);
};

/**
 * Returns an action to be dispatched for deleting the specified Multi Entity.
 * @param {number} engagementId The engagement's Id.
 * @param {number} stEntityId The multi entity Id.
 * @returns {object} The action to be dispatched.
 */
export const deleteMultiEntity = (engagementId, stEntityId, actionProps) => {
	return createApiDeleteAction(
		types.DELETE_MULTI_ENTITY,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: stEntityId
		},
		{
			...actionProps,
			stEntityId
		}
	);
};

export function getEngagementEntities(engagementId, queryString) {
	return createApiReadAction(
		types.GET_ALL_ENGAGEMENT_ENTITIES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: null
		},
		queryString
	);
}

export function setSelectedStEntityId(stEntityId) {
	return {
		type: types.SET_SELECTED_STENTITY_ID,
		stEntityId
	};
}

export function clearSelectedStEntityId() {
	return {
		type: types.CLEAR_SELECTED_STENTITY_ID
	};
}

export function mapEntitiesToBusinessUnits(engagementId, helixProjectId, entities) {
	let url = `${env.getServerUrl('Engagements')}/${engagementId}/HelixProjects/${helixProjectId}/MappedEntities`;
	return {
		type: types.MAP_ENTITIES_TO_BUSINESS_UNITS,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: {
					engagementId: engagementId,
					projectId: helixProjectId,
					mappedEntities: entities
				}
			}
		}
	};
}

export const updateEntityDocumentRelate = (engagementId, entityId, docId) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}/MultiEntity/${entityId}/documents`;
	const data = {
		documentId: docId
	};
	return {
		type: types.UPDATE_ENTITY_DOCUMENT_RELATE,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		}
	};
};

export const deleteEntityDocumentRelate = (engagementId, entityId, docId) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}/MultiEntity/${entityId}/documents/${docId}`;
	return {
		type: types.DELETE_ENTITY_DOCUMENT_RELATE,
		documentId: docId,
		stEntityId: entityId,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		}
	};
};
